import { render, staticRenderFns } from "./InsBanner.vue?vue&type=template&id=ee8f62b2&scoped=true&"
import script from "./InsBanner.vue?vue&type=script&lang=ts&"
export * from "./InsBanner.vue?vue&type=script&lang=ts&"
import style0 from "./InsBanner.vue?vue&type=style&index=0&id=ee8f62b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8f62b2",
  null
  
)

export default component.exports